var round = function (value, decimals) {
    if (decimals === void 0) { decimals = 0; }
    var multiplier = Math.pow(10, decimals);
    return Math.round(value * multiplier) / multiplier;
};
export { round };
